// extracted by mini-css-extract-plugin
export var container = "toms-module--container--76b93";
export var mainText = "toms-module--mainText--04b07";